import CronComponent from "components/CronComponent";
import SelectComponent from "components/form/Select";
import RadioButton from "components/form/Radio";
import statusList from "content/radioCommon";
import { Modal, Button, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import automationClient from "lib/automation-client";
import { ChevronRight } from "lucide-react";

function UpdateInsertModal({ loadParam, handleAddField, showModal, handleClose, handleSubmit, isEditing, requestData, handleInputChange, params, handleChange }) {
    const [collectionList, setCollectionList] = useState([]);
    const fetchMasterList = async () => {
        const { data, error } = await automationClient.masterList()
        if (error) {
            return
        }
        setCollectionList([...data])
    }
    useEffect(() => {
        if (showModal) {
            fetchMasterList()
        }
    }, [showModal]);
    return (
        <Modal show={showModal} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header>
                <Modal.Title>
                    {isEditing ? "Edit " : "Create "}Automation
                </Modal.Title>
                <button className="btn btn-sm btn-secondary" onClick={handleClose}>X</button>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={requestData.name}
                            onChange={(e) => handleInputChange('name', e.target.value)}
                            required
                        />
                    </Form.Group>
                    <SelectComponent
                        label={"Master"}
                        onChange={(e) => {
                            handleInputChange("automationName", e.target.value)
                            // setErrorHandle("role", undefined)
                        }}
                        // errorMessage={errorMessage.role}
                        optionList={collectionList}
                        value={requestData.automationName}
                        className="mb-1  mt-0"
                        firstOption={"Please select Master"}
                    />
                    <CronComponent value={requestData.expression} handle={handleInputChange} />
                    <div className="d-flex flex-row">

                    <RadioButton
                        elementStyle={{ cursor: "pointer" }}
                        label={"Status"}
                        radioBtnList={statusList}
                        className={"w-100 mt-1 mb-3"}
                        value={requestData.status}
                        handleRadioChange={(e) => handleInputChange('status', e.target.value)}
                    />
                    
                    <div style={{width:1000}}>
                        <label htmlFor={'Other'} className="form-label">
                            Collection
                        </label>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={"Truncate Collection"}
                            checked={requestData.truncate}
                            onChange={e => handleInputChange('truncate', e.target.checked)}
                        />
                        </div>
                    </div>
                    <label htmlFor={'database type'} className="form-label">
                        Database Flow
                    </label>
                    <div className="d-flex justify-content-between ">
                        <div>
                            <FlowTitle title={"EIS Database Type:"} />
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                label="EIS Live database "
                                checked={requestData.isLive}
                                onChange={e => handleInputChange('isLive', e.target.checked)}
                            />
                        </div>
                        <ArrowFlow />
                        <div>
                            <FlowTitle title={"Middleware Database:"} />
                            <Form.Select
                                value={requestData.middlewareDB}
                                onChange={e => handleInputChange('middlewareDB', e.target.value)}
                                id="Middleware Database:"
                                aria-label="Default select example"
                            >
                                <option>Select middleware DB</option>
                                <option value="live">live DB</option>
                                <option value="mf">MF DB</option>
                                <option value="demo">Demo DB</option>
                            </Form.Select>
                        </div>
                        <ArrowFlow />
                        <div>
                            <FlowTitle title={"Production Database:"} />
                            <Form.Select
                                value={requestData.proDB}
                                onChange={e => handleInputChange('proDB', e.target.value)}
                                id="Production Database:"
                                aria-label="Default select example"
                            >
                                <option>Select middleware DB</option>
                                <option value="mf">MF DB</option>
                                <option value="qa">Production DB</option>
                                <option value="pgsql_qa">Postgresql DB</option>
                                <option value="production_prismara">Production Prismara</option>
                                <option value="production_sugerock">Production Sugerock</option>
                            </Form.Select>
                        </div>
                    </div>

                    <label htmlFor="factoryCode" className="form-label">
                        Parameter
                    </label>
                    <div style={{ padding: '20px', }} className="d-flex flex-column justify-content-center">
                        {params?.map((field, index) => (
                            <div key={index} style={{ display: 'flex', gap: 5, marginBottom: '10px' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                                    <input
                                        type="text"
                                        placeholder="name"
                                        value={field.name}
                                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                                        className="mr-1"
                                    />
                                    :
                                </div>
                                <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'row' }}>
                                    <input
                                        type="text"
                                        placeholder="Value"
                                        value={field.value}
                                        onChange={(e) => handleChange(index, 'value', e.target.value)}
                                        className="w-100"

                                    />
                                    {/* <Button variant={'link'} className="p-0">
                                        <X color="red" />
                                    </Button> */}
                                </div>
                            </div>
                        ))}
                        <div className="d-flex justify-content-center">
                            <Button type="button" style={{ width: 100 }} variant={'link'} onClick={loadParam}>Load env</Button>
                            {/* <Button type="button" class="btn btn-info d-flex" variant={'info'} onClick={handleAddField}>+ Add Parameter</Button> */}
                        </div>

                    </div>

                    <Button variant="primary" className="w-100 mt-4" type="submit">
                        {isEditing ? "Update" : "Submit"}
                    </Button>

                </Form>
            </Modal.Body>
        </Modal>
    );
}
const ArrowFlow = () => <div className="d-flex align-items-center">
    <ChevronRight size={30} />
</div>
const FlowTitle = ({ title }) => <label htmlFor={title} className="form-label text-dark " style={{ fontSize: 14 }}>
    {title}
</label>

export default UpdateInsertModal;
